export default "__VITE_ASSET__DZo20Gje__"